import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {
  goToPage,
  stepParams,
  setEquipmentReturnMethod,
  setDelivery,
  setMobileToPickUp,
  setNotesToPickUp,
} from '../../DisconnectServiceSlice';
import RadioInput from '../../../../Shared/RadioInput/RadioInput';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import images from '../../DisconnectPhotos/images';
import DisplaySelfReturn from './DisplaySelfReturn';
import DisplayDeliveryWindow from './DisplayDeliveryWindow';
import {Container, Row} from 'reactstrap';
import gaParams from '../../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../../utilities/analytics/tracking';
import useExtendedEffect from '../../../../../utilities/hooks/useExtendedEffect';

function DeliveryProductsPage(props) {
  const [checkedSelf, setCheckedSelf] = useState(false);
  const [checkedDelivery, setCheckedDelivery] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const [mobileError, setMobileError] = useState(false);

  const displayPrice = '₪' + props.cost;

  function handleSelectSelfOption(method) {
    props.setEquipmentReturnMethod(method);
    setCheckedSelf(!checkedSelf);
    setCheckedDelivery(false);
  }

  function handleSelectDeliveryOption(method) {
    props.setEquipmentReturnMethod(method);
    setCheckedDelivery(!checkedDelivery);
    setCheckedSelf(false);
  }

  function checkMethodExists(method) {
    let boolean = props.method.includes(method);
    return boolean;
  }

  function checkIsAddressValid() {
    if (props.addressForm.street !== '' && props.addressForm.city !== '' && props.addressForm.home !== '') {
      const data = {
        id: props.serviceToDisconnect.productId,
        city: props.addressForm.city,
        street: props.addressForm.street,
        house: props.addressForm.home,
      };
      props.setDelivery(data);
      setIsValid(true);
    }
  }

  useEffect(() => {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }
    gaEvent(
      gaParams.DISCONNECT_ENTER_DELIVERY_PRODUCT_PAGE.category,
      gaParams.DISCONNECT_ENTER_DELIVERY_PRODUCT_PAGE.eventType,
      props.serviceToDisconnect.serviceType,
    );
  }, []);

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.addressForm.street !== '' && props.addressForm.city !== '' && props.addressForm.home !== '') {
          const data = {
            id: props.serviceToDisconnect.productId,
            city: props.addressForm.cityName,
            street: props.addressForm.streetName,
            house: props.addressForm.home,
          };
          props.setDelivery(data);
          setIsValid(true);
        }
      }
    },
    [props.addressForm.home],
  );

  useEffect(() => {
    if (props.mobileErrors.errors && props.mobileErrors.errors.cellular) {
      if (props.mobileErrors.errors.cellular !== '') {
        setMobileError(true);
      }
    }
    if (props.mobileErrors.errors.cellular === '' && props.mobileErrors.valid == '') {
      setMobileError(false);
    }
  }, [props.mobileErrors.errors.cellular]);

  function redirectTo() {
    if (checkedSelf || checkMethodExists('החזרה עצמית')) {
      gaEvent(
        gaParams.DISCONNECT_CLICK_CONTINUE_PRODUCT_PAGE.category,
        gaParams.DISCONNECT_CLICK_CONTINUE_PRODUCT_PAGE.eventType,
        props.method,
      );
      props.goToPage({page: 'SELF_PRODUCT_RETURN_PAGE', params: {...stepParams, hideHeader: true}});
    }
    if (
      checkedDelivery ||
      (checkMethodExists('עם שליח') &&
        props.addressForm.street !== '' &&
        props.addressForm.city !== '' &&
        props.addressForm.home !== '' &&
        props.pickup != '')
    ) {
      gaEvent(
        gaParams.DISCONNECT_CLICK_CONTINUE_PRODUCT_PAGE.category,
        gaParams.DISCONNECT_CLICK_CONTINUE_PRODUCT_PAGE.eventType,
        props.method,
      );
      props.goToPage({page: 'PICK_UP_PRODUCT_RETURN_PAGE', params: {...stepParams, hideHeader: true}});
    }
  }

  return (
    <Container className='DeliveryProducts-root'>
      <Row className='header-row'>
        <h3 className='header-big'>החזרת הציוד</h3>
        <h6 className='header'>איך יהיה לך נוח להחזיר את הציוד?</h6>
      </Row>
      <Row className='delivery-box-row'>
        <div className='delivery-box'>
          <div className='option'>
            <RadioInput
              onChange={() => {
                handleSelectSelfOption('החזרה עצמית');
              }}
              id='self'
              name='groupDeliveries'
              value='self-return'
              checked={checkMethodExists('החזרה עצמית')}
            />
            <Image className='imgs' alt='you return' src={images.selfReturnPurple} />
            <span style={{color: '#4a4a4a'}}>
              <strong>החזרה עצמית</strong>
            </span>
          </div>
          <div className='option'>
            <RadioInput
              onChange={() => {
                handleSelectDeliveryOption('עם שליח');
              }}
              id='company'
              name='groupDeliveries'
              value='delivery'
              checked={checkMethodExists('עם שליח')}
            />
            <Image className='imgs' alt='truck' src={images.deliveryPurple} />
            <span style={{color: '#4a4a4a'}}>
              <strong>עם שליח</strong>
            </span>
            <div className='price'>{displayPrice}</div>
          </div>
        </div>
      </Row>
      <Row className='pop-choice-row'>
        {checkedSelf || checkMethodExists('החזרה עצמית') ? <DisplaySelfReturn /> : null}
        {checkedDelivery || checkMethodExists('עם שליח') ? (
          <DisplayDeliveryWindow onValid={() => checkIsAddressValid()} isSubmit={isSubmit} />
        ) : null}
      </Row>
      <Row className='btn-row'>
        <div className={`btn-wrapper${(checkedDelivery && props.pickup == '') || mobileError === true ? ' Off' : ''}`}>
          <BtnSubmit text='המשך' onclick={() => redirectTo()} />
        </div>
      </Row>
    </Container>
  );
}

const mapStateToProps = (state) => ({
  stepParams: state.disconnectServicesBlock.stepParams,
  serviceToDisconnect: state.disconnectServicesBlock.serviceToDisconnect,
  addressForm: state.addressForm.form,
  slots: state.disconnectServicesBlock.deliverySlotsResponse,
  pickup: state.disconnectServicesBlock.summarizeUserDisconnectDetails.timeDisconnectScheduled,
  method: state.disconnectServicesBlock.summarizeUserDisconnectDetails.equipmentReturnMethod,
  mobileErrors: state.disconnectServicesBlock.summarizeUserDisconnectDetails.returnToNumberForm,
});

const mapDispatchToProps = {
  goToPage,
  setEquipmentReturnMethod,
  setNotesToPickUp,
  setDateToPickUp,
  setMobileToPickUp,
  setDelivery,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryProductsPage);
